import axios from "axios";
import { useState, useEffect } from "react";
import { Modal } from "bootstrap";

const AddCategory = () => {

    const [categories, setCategories] = useState([]);
    const [name, setName] = useState("");
    const [images, setImages] = useState([""]);
    const [editingId, setEditingId] = useState(null);


    // FETCH CATEGORIES + EVENT CATEGORIES
    const fetchCategories = async () => {

        const [catRes, eventRes] = await Promise.all([
            axios.get("https://ezer-eventapp.onrender.com/categories"),
            axios.get("https://ezer-eventapp.onrender.com/events")
        ]);

        const dbCategories = catRes.data;

        const eventCategories = [
            ...new Set(eventRes.data.flatMap(e => e.categories))
        ];

        const merged = eventCategories.map(catName => {

            const existing = dbCategories.find(c => c.name === catName);

            return existing || {
                _id: null,
                name: catName,
                images: []
            };

        });

        setCategories(merged);

    };

    useEffect(() => {
        fetchCategories();
    }, []);


    // IMAGE FUNCTIONS

    const addImage = () => {
        setImages([...images, ""]);
    };

    const updateImage = (i, value) => {
        const updated = [...images];
        updated[i] = value;
        setImages(updated);
    };

    const removeImage = (i) => {
        if (images.length === 1) return;
        setImages(images.filter((_, index) => index !== i));
    };


    // OPEN EDIT MODAL

    const editCategory = (cat) => {

        setName(cat.name);
        setImages(cat.images?.length ? cat.images : [""]);
        setEditingId(cat._id || null);

        const modalEl = document.getElementById("editModal");

        let modal = Modal.getInstance(modalEl);

        if (!modal) {
            modal = new Modal(modalEl);
        }

        modal.show();

    };


    // SAVE CATEGORY

    const submitHandler = async (e) => {

        e.preventDefault();

        const payload = {
            name: name.trim(),
            images: images.filter(img => img.trim() !== "")
        };

        try {

            if (editingId) {

                await axios.put(
                    `https://ezer-eventapp.onrender.com/categories/${editingId}`,
                    payload
                );

            } else {

                await axios.post(
                    "https://ezer-eventapp.onrender.com/categories",
                    payload
                );

            }

            fetchCategories();

            setName("");
            setImages([""]);
            setEditingId(null);


            // CLOSE MODAL

            const modalEl = document.getElementById("editModal");

            let modal = Modal.getInstance(modalEl);

            if (modal) {
                modal.hide();
            }

            setTimeout(() => {

                document.body.classList.remove("modal-open");

                document.querySelectorAll(".modal-backdrop")
                    .forEach(el => el.remove());

            }, 200);

        } catch (err) {

            console.error(err);
            alert("Error saving category");

        }

    };


    // DELETE CATEGORY

    const deleteCategory = async (id) => {

        if (!id) return alert("Category only exists in events");

        if (!window.confirm("Delete category?")) return;

        await axios.delete(`https://ezer-eventapp.onrender.com/categories/${id}`);

        fetchCategories();

    };



    return (

        <div className="container py-5">

            <h3 className="mb-4">Category Manager</h3>

            <div className="row">

                {categories.map((cat) => (

                    <div key={cat.name} className="col-md-3 mb-4">

                        <div className="card shadow-sm h-100">

                            {cat.images?.length > 0 ? (

                                <img
                                    src={cat.images[0]}
                                    className="card-img-top"
                                    style={{ height: "180px", objectFit: "cover" }}
                                />

                            ) : (

                                <div
                                    className="bg-light d-flex align-items-center justify-content-center"
                                    style={{ height: "180px" }}
                                >
                                    No Image
                                </div>

                            )}

                            <div className="card-body text-center">

                                <h6>{cat.name}</h6>

                                <div className="d-flex justify-content-center gap-2">

                                    <button
                                        className="btn btn-sm btn-warning"
                                        onClick={() => editCategory(cat)}
                                    >
                                        Edit
                                    </button>

                                    {cat._id && (

                                        <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() => deleteCategory(cat._id)}
                                        >
                                            Delete
                                        </button>

                                    )}

                                </div>

                            </div>

                        </div>

                    </div>

                ))}

            </div>



            {/* EDIT MODAL */}

            <div
                className="modal fade"
                id="editModal"
                tabIndex="-1"
                data-bs-backdrop="static"
            >

                <div className="modal-dialog modal-lg">

                    <div className="modal-content">

                        <div className="modal-header">

                            <h5 className="modal-title">
                                Edit Category
                            </h5>

                            <button
                                className="btn-close"
                                data-bs-dismiss="modal"
                            />

                        </div>


                        <div className="modal-body">

                            <form onSubmit={submitHandler}>

                                <input
                                    className="form-control mb-3"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Category Name"
                                />


                                <h6>Images</h6>

                                {images.map((img, i) => (

                                    <div key={i} className="d-flex gap-2 mb-2">

                                        <input
                                            className="form-control"
                                            value={img}
                                            placeholder="Image URL"
                                            onChange={(e) => updateImage(i, e.target.value)}
                                        />

                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => removeImage(i)}
                                        >
                                            ❌
                                        </button>

                                    </div>

                                ))}


                                <button
                                    type="button"
                                    className="btn btn-secondary mb-3"
                                    onClick={addImage}
                                >
                                    Add Image
                                </button>


                                <button className="btn btn-primary w-100">
                                    Save Category
                                </button>

                            </form>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default AddCategory;